import { render, staticRenderFns } from "./node-resolver.vue?vue&type=template&id=60e335a8&scoped=true"
import script from "./node-resolver.vue?vue&type=script&lang=js"
export * from "./node-resolver.vue?vue&type=script&lang=js"
import style0 from "./node-resolver.vue?vue&type=style&index=0&id=60e335a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e335a8",
  null
  
)

export default component.exports